export default __webpack_public_path__ + "static/media/WhatsApp_Dis.7cfee9fb.svg";